import { Testimonials } from '@frontendmentorio/design-system-v2';

export default function Testimonials1() {
  return (
    <div className="px-5 tablet:pb-6">
      <Testimonials>
        <Testimonials.Card
          avatar="/static/images/pro-avatar-emmilie.webp"
          name="Emmilie"
          title="@emestabillo"
        >
          Frontend Mentor gave me portfolio-ready projects and real-world
          experience that set me apart in interviews. The supportive community
          and premium challenges directly helped me land my first developer job.
        </Testimonials.Card>

        <Testimonials.Card
          avatar="/static/images/pro-avatar-kent.webp"
          name="Kent"
          title="@12Kentos"
        >
          Frontend Mentor’s projects helped me build real-world coding skills
          and land my first programming job. Upgrading to Pro was worth it for
          the premium challenges, and the supportive community made learning
          even more rewarding.
        </Testimonials.Card>
      </Testimonials>
    </div>
  );
}
